window.VedaGoldRate = (function () {
  var API_URL = 'https://app.stag.givadiva.co/v2/products/goldPriceWithCarat?pos_region=';
  var API_TOKEN = 'Cs5vV8weH9oRcEqaD0ugQlwzAbDosw';
  var cache = null;
  var pending = null;

  function get() {
    if (cache) return Promise.resolve(cache);
    if (pending) return pending;

    pending = fetch(API_URL, { headers: { xaccesstoken: API_TOKEN } })
      .then(function (res) {
        if (!res.ok) throw new Error('VedaGoldRate: request failed with ' + res.status);
        return res.json();
      })
      .then(function (json) {
        if (!json || !json.success || !Array.isArray(json.data)) {
          throw new Error('VedaGoldRate: unexpected response shape');
        }
        var rates = {};
        json.data.forEach(function (row) {
          rates[row.carat] = row.price;
        });
        cache = rates;
        pending = null;
        return rates;
      })
      .catch(function (err) {
        pending = null;
        throw err;
      });

    return pending;
  }

  return { get: get };
})();
